import { render, staticRenderFns } from "./payHead.vue?vue&type=template&id=62383699&scoped=true&"
import script from "./payHead.vue?vue&type=script&lang=js&"
export * from "./payHead.vue?vue&type=script&lang=js&"
import style0 from "./payHead.vue?vue&type=style&index=0&id=62383699&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62383699",
  null
  
)

export default component.exports